import './about.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight,
  faShieldAlt,
  faUserCheck,
  faUndo,
  faCertificate,
  faFileAlt,
  faGavel,
  faPhone,
  faEnvelope,
  faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";


const ANPC = () => {
  return (
  
      <div className="general-container-footer-info-ab">
                 <div className="info-footer-container-ab">
           
                   <section className='section-about-1'>
                       <div>
                           <h3 className='align-about-ab'>
             <span className='acasa-about-footer'>Acasa</span>
             <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
           
             <span className='color-despre'>Protecția Consumatorului</span>
           </h3>
                       </div>
                     
                     
                   </section>


                     <div className='tittle-ab-top'>
                        <h4>Protecția Consumatorului - ANPC</h4>
                    </div>
           
                   
           
                {/* Introducere ANPC */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faShieldAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Ce este ANPC?</h4>
    <p>
      Autoritatea Națională pentru Protecția Consumatorilor (ANPC) este instituția publică din România care 
      asigură protecția drepturilor consumatorilor și supraveghează piața în ceea ce privește siguranța produselor și serviciilor.
    </p>
    <p>
      ContaLearn respectă legislația privind protecția consumatorilor și se angajează să ofere servicii educaționale 
      conforme cu standardele legale românești.
    </p>
    <p><strong>Legislație aplicabilă:</strong> Legea nr. 296/2004 privind Codul Consumului (actualizată)</p>
  </div>
</section>

{/* Drepturile consumatorilor */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Drepturile consumatorilor conform Legii 296/2004</h4>
    <p>
      Ca utilizator al platformei ContaLearn, beneficiezi de următoarele drepturi fundamentale:
    </p>
    <ul style={{marginTop: '15px'}}>
      <li style={{marginBottom: '10px'}}>
        <strong>🛡️ Dreptul la protecția sănătății și securității</strong> — Serviciile să nu pună în pericol viața, sănătatea sau securitatea
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>💰 Dreptul la protecția intereselor economice</strong> — Prețuri corecte, fără clauze abuzive
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>📋 Dreptul la informare</strong> — Informații complete, corecte și precise despre servicii
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>📚 Dreptul la educație pentru consum</strong> — Acces la informații pentru alegeri în cunoștință de cauză
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>⚖️ Dreptul de a fi reprezentat și audiat</strong> — Posibilitatea de a-și exprima interesele
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>💳 Dreptul la despăgubire</strong> — Compensații pentru prejudicii cauzate de servicii neconforme
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>🏛️ Dreptul de a se adresa justiției</strong> — Acces la mecanisme de soluționare a litigiilor
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>🔄 Dreptul de retragere</strong> — Anularea contractului în termen de 14 zile (pentru contracte la distanță)
      </li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faUserCheck} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Dreptul de retragere */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faUndo} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Dreptul de retragere din contract (OUG 34/2014)</h4>
    <p>
      Pentru contractele încheiate la distanță (online), ai dreptul să te retragi din contract în termen de 
      <strong> 14 zile calendaristice</strong>, fără a fi nevoie să justifici decizia și fără penalități.
    </p>
    <p><strong>Termenul de 14 zile începe:</strong></p>
    <ul>
      <li>▸ De la data încheierii contractului pentru servicii digitale</li>
      <li>▸ De la data activării abonamentului premium</li>
    </ul>
    <p><strong>Cum exerciți dreptul de retragere:</strong></p>
    <ul>
      <li>✓ Trimite o solicitare clară la <strong>suport@contalearn.ro</strong></li>
      <li>✓ Menționează în email: "Solicitare de retragere din contract"</li>
      <li>✓ Include datele de identificare (nume, email, dată achiziție)</li>
    </ul>
    <p><strong>Rambursare:</strong></p>
    <p>
      Vom rambursa suma plătită în termen de <strong>14 zile</strong> de la primirea solicitării de retragere, 
      folosind aceeași metodă de plată utilizată inițial, cu condiția să nu fi fost accesat și finalizat niciun modul complet al cursului.
    </p>
    <div style={{background: '#fff3cd', padding: '15px', borderRadius: '10px', marginTop: '15px', border: '2px solid #ffc107'}}>
      <p style={{margin: 0}}><strong>⚠️ Excepție:</strong> Dreptul de retragere nu se aplică pentru serviciile digital-educaționale 
      deja prestate integral cu acordul explicit al consumatorului.</p>
    </div>
  </div>
</section>

{/* Garantie si conformitate */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Garanția și conformitatea serviciilor</h4>
    <p>
      Serviciile educaționale oferite de ContaLearn trebuie să fie conforme cu descrierea prezentată și 
      să corespundă scopului pentru care sunt utilizate în mod normal.
    </p>
    <p><strong>Ce înseamnă "lipsă de conformitate":</strong></p>
    <ul>
      <li>▸ Serviciul nu corespunde descrierii din prezentarea inițială</li>
      <li>▸ Funcționalitățile promise nu sunt disponibile</li>
      <li>▸ Conținutul este incomplet sau incorect în mod semnificativ</li>
      <li>▸ Platforma nu funcționează conform specificațiilor tehnice</li>
    </ul>
    <p><strong>Drepturile tale în caz de neconformitate:</strong></p>
    <ul>
      <li>✓ Solicitarea remedierii neconformității</li>
      <li>✓ Reducerea proporțională a prețului</li>
      <li>✓ Rezoluțiunea contractului cu rambursarea integrală</li>
    </ul>
    <p>
      Pentru sesizarea unei neconformități, contactează-ne la <strong>suport@contalearn.ro</strong> cu descrierea detaliată a problemei.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faCertificate} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Clauze abuzive */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faExclamationCircle} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Protecție împotriva clauzelor abuzive</h4>
    <p>
      Conform legislației privind protecția consumatorilor, clauzele contractuale abuzive sunt interzise și considerate nule.
    </p>
    <p><strong>Exemple de clauze abuzive (conform Legii 296/2004):</strong></p>
    <ul>
      <li>✗ Excluderea sau limitarea răspunderii pentru vătămări corporale</li>
      <li>✗ Limitarea nejustificată a dreptului de reziliere</li>
      <li>✗ Prelungirea automată a contractului fără notificare prealabilă</li>
      <li>✗ Modificarea unilaterală a prețului fără drept de retragere</li>
      <li>✗ Obligarea consumatorului la plata unor servicii nesolicitate</li>
    </ul>
    <p><strong>Angajamentul ContaLearn:</strong></p>
    <p>
      Ne angajăm să utilizăm termeni contractuali transparenți, echitabili și conformi cu legislația română. 
      Orice clauză considerată abuzivă poate fi contestată și este nulă de drept.
    </p>
  </div>
</section>

{/* Cum depui o reclamatie */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Cum depui o reclamație la ANPC?</h4>
    <p>
      Dacă consideri că drepturile tale ca și consumator au fost încălcate, poți depune o reclamație la ANPC prin:
    </p>
    
    <h5 style={{color: '#13b8ab', marginTop: '20px'}}>1️⃣ Online - Platforma SOL (Soluționarea Online a Litigiilor)</h5>
    <ul>
      <li>🌐 Accesează: <a href='https://ec.europa.eu/consumers/odr' target='_blank' rel='noopener noreferrer'>ec.europa.eu/consumers/odr</a></li>
      <li>📝 Completează formularul de reclamație</li>
      <li>📧 Primești notificări prin email despre stadiul soluționării</li>
    </ul>

    <h5 style={{color: '#13b8ab', marginTop: '20px'}}>2️⃣ Prin email sau poștă</h5>
    <ul>
      <li>📧 Email: <strong>office@anpc.ro</strong></li>
      <li>📬 Adresă: B-dul Aviatorilor nr. 72, Sector 1, București, cod poștal 011865</li>
    </ul>

    <h5 style={{color: '#13b8ab', marginTop: '20px'}}>3️⃣ La sediul ANPC sau comisariatele județene</h5>
    <p>Poți depune reclamația personal la oricare dintre comisariatele județene ANPC.</p>

    <p style={{marginTop: '20px'}}><strong>Ce trebuie să conțină reclamația:</strong></p>
    <ul>
      <li>▸ Datele tale de identificare (nume, adresă, telefon, email)</li>
      <li>▸ Datele operatorului economic (ContaLearn)</li>
      <li>▸ Descrierea detaliată a problemei</li>
      <li>▸ Dovezi (capturi ecran, email-uri, chitanțe, contracte)</li>
      <li>▸ Solicitările tale concrete</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faFileAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Solutionarea Alternativa a Litigiilor */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faGavel} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Soluționarea Alternativă a Litigiilor (SAL)</h4>
    <p>
      Conform Legii 192/2006, poți apela la proceduri alternative de soluționare a litigiilor cu consumatorii:
    </p>
    
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <h5 style={{margin: '0 0 10px 0', color: '#13b8ab'}}>🇪🇺 Platforma SOL (Online Dispute Resolution)</h5>
      <p style={{margin: '5px 0'}}>Platforma europeană pentru soluționarea online a litigiilor</p>
      <p style={{margin: '5px 0'}}><strong>🌐 Link:</strong> <a href='https://ec.europa.eu/consumers/odr' target='_blank' rel='noopener noreferrer'>ec.europa.eu/consumers/odr</a></p>
      <p style={{margin: '5px 0'}}>Această platformă facilitează rezolvarea extrajudiciară a litigiilor între consumatori și comercianți din UE.</p>
    </div>

    <p style={{marginTop: '20px'}}><strong>Avantajele SAL:</strong></p>
    <ul>
      <li>✓ Procedură mai rapidă decât instanța</li>
      <li>✓ Costuri reduse sau inexistente</li>
      <li>✓ Confidențialitate</li>
      <li>✓ Soluții consensuale</li>
    </ul>

    <p style={{marginTop: '15px'}}>
      <strong>Important:</strong> Utilizarea SAL nu te împiedică să apelezi ulterior la instanțele judecătorești dacă nu ești mulțumit de rezultat.
    </p>
  </div>
</section>

{/* Contact ANPC */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Contact ANPC</h4>
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <h5 style={{margin: '0 0 10px 0', color: '#13b8ab'}}>🏛️ Autoritatea Națională pentru Protecția Consumatorilor</h5>
      <p style={{margin: '5px 0'}}><strong>📍 Adresă:</strong> B-dul Aviatorilor nr. 72, Sector 1, București, cod poștal 011865</p>
      <p style={{margin: '5px 0'}}><strong>📞 Telefon:</strong> 021.9551 (Luni - Vineri: 08:00 - 20:00)</p>
      <p style={{margin: '5px 0'}}><strong>📧 Email:</strong> office@anpc.ro</p>
      <p style={{margin: '5px 0'}}><strong>🌐 Website:</strong> <a href='https://anpc.ro' target='_blank' rel='noopener noreferrer'>www.anpc.ro</a></p>
      <p style={{margin: '5px 0'}}><strong>📱 Tel Verde:</strong> 0800.080.999 (gratuit din orice rețea)</p>
    </div>

    <p style={{marginTop: '20px'}}><strong>📍 Găsește comisariatul județean:</strong></p>
    <p>ANPC are comisariate în fiecare județ. Lista completă se găsește pe: 
    <a href='https://anpc.ro/ce-face-anpc/oficii-teritoriale/' target='_blank' rel='noopener noreferrer'> anpc.ro/oficii-teritoriale</a></p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faPhone} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Contact ContaLearn */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEnvelope} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Rezolvarea directă cu ContaLearn</h4>
    <p>
      Înainte de a depune o reclamație la ANPC, te încurajăm să ne contactezi direct pentru a încerca să rezolvăm situația rapid și amiabil.
    </p>
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <p style={{margin: '5px 0'}}><strong>📩 Email suport:</strong> suport@contalearn.ro</p>
      <p style={{margin: '5px 0'}}><strong>📝 Subiect:</strong> "Reclamație consumator - [descriere scurtă]"</p>
      <p style={{margin: '5px 0'}}><strong>⏱️ Timp de răspuns:</strong> Maximum 48 ore lucrătoare</p>
    </div>
    <p style={{marginTop: '15px'}}>
      Suntem dedicați să oferim servicii de calitate și să rezolvăm orice problemă în cel mai scurt timp posibil. 
      Feedback-ul tău ne ajută să îmbunătățim constant platforma.
    </p>
  </div>
</section>

           
            <div className='line-about'></div>
           
                 
           
                 </div>
               </div>
   
  );
};

export default ANPC;
